export default __webpack_public_path__ + "static/media/BF.a5177706.svg";